import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import ComponentAutocomplete from "App/Component/Autocomplete";
import descriptor from "./descriptor";
import options from "./options";

const title = "Product Parent Groups";
const urlData = "productParentGroups";
const bulkName = "name";
const children = {
    appName: 'estimation',
    modelName: 'productgroup',
    name: 'productParentGroups',
    sub: 'productGroups', // 'products',
    dataIndex: 'productGroups', // 'products',
    // bulk_request: true,
    urlSub: 'api:admin:estimation:productgroup:list',
    paramProps: { parents: 'pk' },
    add: true,
    edit: true,
    data: false,
    identifier: {
      name: 'parents',
      is_array: true
    },
    permissions: {
      payload: true,
      bulk_delete: false,
      initialrow: 1,
      add:true
    },
    rules: {
      button: {
        type: {
          add: 'default',
          edit: 'default'
        },
        size: 'small'
      },
      input: {
        size: 'small'
      },
      select: {
        size: 'small'
      }
    },
  fields: ComponentAutocomplete['productGroups']
  }

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.children = children
    this.propsDetail = {
      // urlKeyHistory: 'api:admin:estimation:productparentgroup:detail-revision',
      keyLabel: 'name'
    }
  }
}

export default { List, Detail };
